import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SuccessIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 80 80" fill="none">
    <circle cx="40" cy="40" r="40" fill="#C2D9CA" />
    <circle cx="40" cy="40" r="32" fill="#D6E5DC" />
    <path
      d="M28 40.5L36 49L53 32"
      stroke="#4A7C5F"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default SuccessIcon;
